
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}},[_c('path',{attrs:{"d":"M18.327 7.286h-8.044a1.93 1.93 0 00-1.925 1.938v10.088c0 1.07.862 1.938 1.925 1.938h8.044a1.93 1.93 0 001.925-1.938V9.224c0-1.07-.862-1.938-1.925-1.938"}}),_c('path',{attrs:{"d":"M15.642 7.286V4.688c0-.514-.203-1.007-.564-1.37a1.92 1.92 0 00-1.361-.568H5.673c-.51 0-1 .204-1.36.568a1.95 1.95 0 00-.565 1.37v10.088c0 .514.203 1.007.564 1.37s.85.568 1.361.568h2.685"}})])])
          )
        }
      }
    